<ng-container
  *ngIf="
    taskRoles
      | filterBy: ['applicable_type']:type
      | filterBy: ['name']:(searchValue$ | async)
      | sortBy: 'asc':'label' as dataSource
  "
>
  <table #fieldsTable mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button matTooltip="Delete Role" (click)="deleteRole(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ disabled: row.hidden }"></tr>
  </table>
  <div class="empty" *ngIf="!dataSource?.length">No data matching the filter.</div>
</ng-container>
